<template>
  <el-container class="container">
    <el-menu
      :default-active="$route.path"
      :collapse="isCollapse"
      :router="true"
      :unique-opened="true"
    >
      <!-- 系统管理 -->
      <template v-for="(item, index) in menuslist">
        <el-menu-item
          v-if="!item.children || (item.children && item.children.length === 0)"
          :index="item.path"
          :key="item.path"
          style="text-align: center"
        >
          <span slot="title">
            {{ languages[item.path][lang] }}
          </span>
        </el-menu-item>

        <TreeMenu
          v-if="item.children && item.children.length"
          :key="index + 's'"
          :item="item"
          :lang="lang"
          :isCollapse="isCollapse"
          :languages="languages"
        />
      </template>
    </el-menu>
    <el-container>
      <el-header>
        <div class="nav-header">
          <Breadcrumb id="hamburger-container" v-model="isCollapse" class="hamburger-container" />
          <my-bread></my-bread>

          <div class="right-menu">
            <el-tooltip :content="$t('home.changeLanguage')" effect="dark" placement="bottom">
              <select-lang />
            </el-tooltip>

            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
              <div class="avatar-wrapper">
                <img
                  src="../../assets/images/home/f778738c-e4f8-4870-b634-56703b4acafe.gif"
                  class="user-avatar"
                />
                <span class="user-name">{{ info.userName }}</span>
                <i class="el-icon-caret-bottom"> </i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <!-- <a @click="dialogVisible = true" v-if="info.userType === 0"> -->
                <a @click="dialogVisible = true">
                  <el-dropdown-item>{{ $t('home.changepasswd') }}</el-dropdown-item>
                </a>

                <!-- <router-link :to="{ name: 'safeCenter' }" v-else>
                  <el-dropdown-item>{{ $t('home.safeCenter') }}</el-dropdown-item>
                </router-link> -->

                <el-dropdown-item divided @click.native="handleSignout()">
                  <span style="display: block">{{ $t('home.loginout') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <TagsViews />
      </el-header>

      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>

    <my-passwd v-model="dialogVisible" />
  </el-container>
</template>

<script>
import selectLang from '@/components/cuscom/select-lang';
import Breadcrumb from '@/components/cuscom/Hamburger';
import myPasswd from '@/components/cuscom/passwd';
import TagsViews from './home-tags-views/index';
import TreeMenu from './home-tree-memu';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'home',
  components: { selectLang, TreeMenu, Breadcrumb, myPasswd, TagsViews },
  data() {
    return {
      dialogVisible: false,
      isCollapse: false
    };
  },
  computed: {
    ...mapState({
      lang: ({ app }) => app.lang,
      info: ({ user }) => user.info
    }),
    ...mapGetters(['roles', 'addRouters', 'languages']),
    menuslist() {
      let routes = this.addRouters.find((item) => item.path === '/');
      function treeToArr(data, res = []) {
        data.forEach((item) => {
          res.push(item);
          if (item.childrenMenus && item.childrenMenus.length !== 0) {
            treeToArr(item.childrenMenus, res);
          }
        });
        return res;
      }
      let arr = treeToArr(this.roles);
      routes.children.forEach((it) => {
        it.children.forEach((ab) => {
          arr.forEach((ac) => {
            if (ab.path.indexOf(ac.menuUrl) > -1) {
              ab.sort = ac.sort;
            }
          });
        });
        it.children.sort((a, b) => {
          if (!a.sort) {
            a.sort = 9999;
          }
          if (!b.sort) {
            b.sort = 9999;
          }
          return a.sort - b.sort;
        });
      });
      return (routes && routes.children) || [];
    }
  },

  created() {
    console.log(this.languages);
  },
  mounted() {
    // if (this.info.userType === 0) {
    //   this.$store.dispatch('WEBSOCKET_INIT');
    // }
  },
  destroyed() {},
  methods: {
    async handleSignout() {
      await this.$store.dispatch('loginOut');
      this.$message.success(this.$t('status.success'));
      this.$router.push({
        name: 'login'
      });
    },

    // 跳转自商户页面
    client() {
      this.$router.push({
        path: '/clientmanage'
      });
    }
  }
};
</script>

<style>
.container {
  height: 100%;
}

#app {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow: auto;
  /* 滚动槽 */
}
#app::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>
<style lang="scss" scoped>
/deep/ .el-header {
  padding-left: 0;
  height: auto !important;
}

.nav-header {
  display: flex;
  align-items: center;
  height: inherit;
}

.right-menu {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: auto;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .user-name {
        position: relative;
        top: -5px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue